<ng-icon [style.color]="color()" [name]="name()">
</ng-icon>
<ng-content></ng-content>
